<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/apppointsshopmanage/add"
      selectShowPower="/activity/selectButton"
    >
      <el-form-item label="名称">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.name"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动编号">
        <el-input
          type="id"
          maxlength="20"
          v-model="formModel.id"
          placeholder="请输入活动编号"
        ></el-input>
      </el-form-item>
      <!-- 查询按钮 -->
      <!-- selectShowPower="/apppointsshopmanage/select" -->
      <!-- <el-form-item label="名称" prop="name">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.name"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item> -->
      <!--<el-form-item label="支付方式">-->
      <!--<el-select v-model="formModel.payTypeScope">-->
      <!--<el-option-->
      <!--v-for="item in payTypeScope"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey"-->
      <!--&gt;-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="name"
        label="名称"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="id"
        label="活动编号"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="chnCode"
        label="通道名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="chnCode2"
        label="子通道名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="simInfo"
        label="流量费活动"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
     {{  scope.row.simInfo ? zhuanhuaLiuliang(scope.row.simInfo) : '--'  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="creditMax"
        label="信用卡最大"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="creditMin"
        label="信用卡最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="creditTat"
        label="信用卡(机构)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="debitMax"
        label="借记卡最大"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="debitMin"
        label="借记卡最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="debitTat"
        label="借记卡(机构)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="wechatQrMax"
        label="微信扫码最大"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="wechatQrMin"
        label="微信扫码最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="wechatQrTat"
        label="微信扫码(机构)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="alipayQrMax"
        label="支付宝最大"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="alipayQrMin"
        label="支付宝最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="alipayQrTat"
        label="支付宝(机构)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ysfQrMax"
        label="银联二维码小额最大"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ysfQrMin"
        label="银联二维码小额最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ysfQrTat"
        label="银联二维码小额(机构)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 新增 -->
      <el-table-column
        prop="ysfQrBigMax"
        label="银联二维码大额最大"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ysfQrBigMin"
        label="银联二维码大额最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ysfQrBigTat"
        label="银联二维码大额(机构)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="otherSimStatus"
        label="是否收藏流量费"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.otherSimStatus == 0">否</span>
          <span v-else-if="scope.row.otherSimStatus == 1">是</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="firstSimAmt"
        label="首笔流量费"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="returnFirstSimAmtTat"
        label="首笔流量费(机构)"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="otherSimAmt"
        label="非首笔流量费"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="returnOtherSimAmtTat"
        label="非首笔流量费(机构)"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="otherSimDays"
        label="周期"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 新增 -->
      <el-table-column
        prop="acqActiveCode"
        label="上游活动编号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="otherAcqActiveCode"
        label="非上游活动编号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="firstDay"
        label="首笔天数"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="lowAmt"
        label="扣流量费的商户最低交易金额"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="batch"
        label="收几次"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column label="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row, true)"
            >复制
          </el-button>
          <el-button
            type="text"
            v-if="hasPerm('/apppointsshopmanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button
            type="text"
            v-if="hasPerm('/apppointsshopmanage/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? (copy ? '复制' : '修改') : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="240px"
      dialogWidth="880px"
      style="display: flex,flex-wrap: wrap"
    >
      <div class="flexBox">
        <el-form-item label="名称" prop="name">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.name"
            placeholder="请输入名称"
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item label="通道名称">
          <el-select style="width: 198px" v-model="dialogModel.chnCode">
            <el-option
              v-for="item in chnCode"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- x -->
        <el-form-item label="子通道名称">
          <el-select style="width: 198px" v-model="dialogModel.chnCode2">
            <el-option
              v-for="item in chnCode2"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div>
        <div class="titleBox">信用卡模块</div>
        <div class="flexBox">
          <el-form-item label="是否显示信用卡">
            <el-radio-group v-model="dialogModel.creditShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="信用卡最大">
            <el-input-number
              v-model="dialogModel.creditMax"
              :controls="false"
              :precision="6"
              :step="0.1"
              controls-position="right"
              :min="0"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="信用卡最小">
            <el-input-number
              v-model="dialogModel.creditMin"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="信用卡(机构)">
            <el-input-number
              v-model="dialogModel.creditTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="是否显示代付费">
            <el-radio-group v-model="dialogModel.withdrawRateShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="代付费分润">
            <el-input-number
              v-model="dialogModel.withdrawRate"
              :controls="false"
              :precision="6"
              :step="0.1"
              controls-position="right"
              :min="0"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="titleBox">借记卡模块</div>
        <div class="flexBox">
          <el-form-item label="是否显示借记卡">
            <el-radio-group v-model="dialogModel.debitShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="借记卡最大">
            <el-input-number
              v-model="dialogModel.debitMax"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="借记卡最小">
            <el-input-number
              v-model="dialogModel.debitMin"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="借记卡(机构)">
            <el-input-number
              v-model="dialogModel.debitTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="titleBox">微信扫码模块</div>
        <div class="flexBox">
          <el-form-item label="是否显示微信扫码">
            <el-radio-group v-model="dialogModel.wechatQrShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="微信扫码最大">
            <el-input-number
              v-model="dialogModel.wechatQrMax"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="微信扫码最小">
            <el-input-number
              v-model="dialogModel.wechatQrMin"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="微信扫码(机构)">
            <el-input-number
              v-model="dialogModel.wechatQrTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="titleBox">支付宝模块</div>
        <div class="flexBox">
          <el-form-item label="是否显示支付宝">
            <el-radio-group v-model="dialogModel.alipayQrShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="支付宝最大">
            <el-input-number
              v-model="dialogModel.alipayQrMax"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="支付宝最小">
            <el-input-number
              v-model="dialogModel.alipayQrMin"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="支付宝(机构)">
            <el-input-number
              v-model="dialogModel.alipayQrTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="titleBox">银联二维码小额模块</div>
        <div class="flexBox">
          <el-form-item label="是否显示银联二维码小额">
            <el-radio-group v-model="dialogModel.ysfQrShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="银联二维码小额最大">
            <el-input-number
              v-model="dialogModel.ysfQrMax"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="银联二维码小额最小">
            <el-input-number
              v-model="dialogModel.ysfQrMin"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="银联二维码小额(机构)">
            <el-input-number
              v-model="dialogModel.ysfQrTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="titleBox">银联二维码大额模块</div>
        <div class="flexBox">
          <el-form-item label="是否显示银联二维码大额">
            <el-radio-group v-model="dialogModel.ysfQrBigShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="银联二维码大额最大">
            <el-input-number
              v-model="dialogModel.ysfQrBigMax"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="银联二维码大额最小">
            <el-input-number
              v-model="dialogModel.ysfQrBigMin"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="银联二维码大额(机构)">
            <el-input-number
              v-model="dialogModel.ysfQrBigTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="6"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="titleBox">流量费模块</div>
        <div class="flexBox">
          <el-form-item label="是否收流量费">
            <el-select
              style="width: 198px"
              v-model="dialogModel.otherSimStatus"
            >
              <el-option
                v-for="item in typeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首笔天数">
            <el-input
              type="text"
              v-model="dialogModel.firstDay"
              placeholder="请输入首笔天数"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item label="扣流量费的商户最低交易金额">
            <el-input-number
              v-model="dialogModel.lowAmt"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <!-- 新增显示 -->
          <el-form-item label="是否显示流量费">
            <el-radio-group v-model="dialogModel.simShow">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="首笔流量费">
            <el-input-number
              v-model="dialogModel.firstSimAmt"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="首笔流量返现">
            <el-input-number
              v-model="dialogModel.returnFirstSimAmt"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="首笔流量返现(机构)">
            <el-input-number
              v-model="dialogModel.returnFirstSimAmtTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="首笔上游活动编号">
            <el-select style="width: 198px" v-model="dialogModel.acqActiveCode">
              <el-option
                v-for="item in typeThreeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="非首笔流量费">
            <el-input-number
              v-model="dialogModel.otherSimAmt"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <!-- 新增 -->

          <el-form-item label="非首笔流量返现">
            <el-input-number
              v-model="dialogModel.returnOtherSimAmt"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="非首笔流量返现(机构)">
            <el-input-number
              v-model="dialogModel.returnOtherSimAmtTat"
              :min="0"
              :max="999999999"
              :step="0.1"
              :precision="2"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="非首笔上游活动编号">
            <el-select
              style="width: 198px"
              v-model="dialogModel.otherAcqActiveCode"
            >
              <el-option
                v-for="item in typeThreeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流量费周期">
            <el-select style="width: 198px" v-model="dialogModel.otherSimDays">
              <el-option
                v-for="item in typeTwoList"
                :key="item.dictKey"
                :label="item.dictKey"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="收几次">
            <el-input
              type="text"
              v-model="dialogModel.batch"
              placeholder="请输入次数"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="考核名称">
            <el-select
              style="width: 198px"
              v-model="dialogModel.hlfConfigThreeId"
            >
              <el-option
                v-for="item in manageArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流量费">
            <el-select
              style="width: 198px"
              multiple
              v-model="dialogModel.simInfo"
            >
              <el-option
                v-for="item in liuliangList"
                :key="item.dictKey"
                :label="item.dictKey"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
             <el-form-item label="是否有长期">
            <el-radio-group v-model="dialogModel.simIsLong">
                <el-radio :label="1">有长期</el-radio>
              <el-radio :label="0">无长期</el-radio>
            
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <!-- 新增 -->

      <!-- 非 -->
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";
import ShopService from "service/ShopService";
import TransactionService from "service/TransactionService";
import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import activity from "service/Ainstitution";
export default {
  name: "apppointsshopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
  },
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
        name: "",
        id: "",
        payTypeScope: "",
      },
      tableData: [],
      submitService: activity.signActivityList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        name: "",
        creditMax: undefined,
        creditMin: undefined,
        debitMax: undefined,
        debitMin: undefined,
        wechatQrMax: undefined,
        wechatQrMin: undefined,
        alipayQrMax: undefined,
        alipayQrMin: undefined,
        ysfQrMax: undefined,
        ysfQrMin: undefined,
        ysfQrBigMax: undefined,
        ysfQrBigMin: undefined,
        otherSimStatus: 0,
        otherSimAmt: undefined,
        firstSimAmt: undefined,
        returnFirstSimAmt: undefined,
        returnOtherSimAmt: undefined,
        otherSimDays: "",
        firstDay: "",
        lowAmt: undefined,
        acqActiveCode: "",
        otherAcqActiveCode: "",
        batch: "",
        hlfConfigThreeId: "",
        returnFirstSimAmtTat: undefined,
        returnOtherSimAmtTat: undefined,
        ysfQrBigTat: undefined,
        ysfQrTat: undefined,
        alipayQrTat: undefined,
        wechatQrTat: undefined,
        debitTat: undefined,
        creditTat: undefined,
        withdrawRate: undefined,
        simShow: 1,
        ysfQrBigShow: 1,
        ysfQrShow: 1,
        alipayQrShow: 1,
        wechatQrShow: 1,
        debitShow: 1,
        creditShow: 1,
        withdrawRateShow: 1,
        simInfo: undefined,
        simIsLong:1
      },

      dialogRules: {
        name: [
          {
            required: true,
            message: "请输入",
          },
        ],
        creditMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        creditMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        wechatQrMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        wechatQrMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        alipayQrMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        alipayQrMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        ysfQrMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        ysfQrMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        otherSimAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
        firstSimAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],

        returnFirstSimAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
        returnOtherSimAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
        otherSimDays: [
          {
            required: true,
            message: "请选择",
          },
        ],
        otherAcqActiveCode: [
          {
            required: true,
            message: "请选择",
          },
        ],
        acqActiveCode: [
          {
            required: true,
            message: "请选择",
          },
        ],
        otherSimStatus: [
          {
            required: true,
            message: "请选择",
          },
        ],
        hlfConfigThreeId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        returnFirstSimAmtTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        returnOtherSimAmtTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        ysfQrBigTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        ysfQrTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        alipayQrTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        wechatQrTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
        creditTat: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      typeList: [
        {
          dictKey: 0,
          dictValue: "否",
        },
        {
          dictKey: 1,
          dictValue: "是",
        },
      ],
      typeTwoList: [],
      typeThreeList: [],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      couponList: [],
      loading: false,
      manageArr: [],
      chnCode: [],
      chnCode2: [],
      liuliangList: [],
      copy: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("流量费", (res) => {
      this.liuliangList = res;
    });
    this.getTypeNames("流量费周期", (res) => {
      this.typeTwoList = res;
    });
    this.getTypeNames("上游活动编号", (res) => {
      this.typeThreeList = res;
    });
    this.getTypeNames("chnName", (res) => {
      this.chnCode = res;
    });
    this.getTypeNames("chnCode2", (res) => {
      this.chnCode2 = res;
    });
  },
  computed: {
    submitData() {
      this.params = {
        name: this.formModel.name,
        id: this.formModel.id,
        payTypeScope: this.formModel.payTypeScope,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      console.log(this.dialogModel.simInfo, "simInfo");
      const params = {
        name: this.dialogModel.name,

        // creditMax: this.dialogModel.creditMax,
        // creditMin: this.dialogModel.creditMin,

        // debitMax: this.dialogModel.debitMax,
        // debitMin: this.dialogModel.debitMin,

        // wechatQrMax: this.dialogModel.wechatQrMax,
        // wechatQrMin: this.dialogModel.wechatQrMin,
        // alipayQrMax: this.dialogModel.alipayQrMax,
        // alipayQrMin: this.dialogModel.alipayQrMin,
        // ysfQrMax: this.dialogModel.ysfQrMax,
        // ysfQrMin: this.dialogModel.ysfQrMin,

        // ysfQrBigMax: this.dialogModel.ysfQrBigMax,
        // ysfQrBigMin: this.dialogModel.ysfQrBigMin,
        otherSimStatus: this.dialogModel.otherSimStatus,
        // otherSimAmt: this.dialogModel.otherSimAmt,
        // firstSimAmt: this.dialogModel.firstSimAmt,
        // //  新
        // returnFirstSimAmt: this.dialogModel.returnFirstSimAmt,
        // returnOtherSimAmt: this.dialogModel.returnOtherSimAmt,
        // otherSimDays: this.dialogModel.otherSimDays,
        // acqActiveCode: this.dialogModel.acqActiveCode,
        // otherAcqActiveCode: this.dialogModel.otherAcqActiveCode,
        // firstDay: this.dialogModel.firstDay,
        // lowAmt: this.dialogModel.lowAmt,

        // batch: this.dialogModel.batch,
        // hlfConfigThreeId: this.dialogModel.hlfConfigThreeId,
        // returnFirstSimAmtTat: this.dialogModel.returnFirstSimAmtTat,
        // returnOtherSimAmtTat: this.dialogModel.returnOtherSimAmtTat,
        // ysfQrBigTat: this.dialogModel.ysfQrBigTat,
        // ysfQrTat: this.dialogModel.ysfQrTat,
        // alipayQrTat: this.dialogModel.alipayQrTat,
        // wechatQrTat: this.dialogModel.wechatQrTat,
        // debitTat: this.dialogModel.debitTat,
        // creditTat: this.dialogModel.creditTat,

        simShow: this.dialogModel.simShow,
        ysfQrBigShow: this.dialogModel.ysfQrBigShow,
        ysfQrShow: this.dialogModel.ysfQrShow,
        alipayQrShow: this.dialogModel.alipayQrShow,
        wechatQrShow: this.dialogModel.wechatQrShow,
        debitShow: this.dialogModel.debitShow,
        creditShow: this.dialogModel.creditShow,
        withdrawRateShow: this.dialogModel.withdrawRateShow,
        simInfo: this.dialogModel.simInfo,
        simIsLong: this.dialogModel.simIsLong
      };

      params.creditMax = this.dialogModel.creditMax;

      params.withdrawRate = this.dialogModel.withdrawRate;

      params.creditMin = this.dialogModel.creditMin;

      params.debitMax = this.dialogModel.debitMax;

      params.debitMin = this.dialogModel.debitMin;

      params.wechatQrMax = this.dialogModel.wechatQrMax;

      params.wechatQrMin = this.dialogModel.wechatQrMin;

      params.alipayQrMax = this.dialogModel.alipayQrMax;

      params.alipayQrMin = this.dialogModel.alipayQrMin;

      params.ysfQrMax = this.dialogModel.ysfQrMax;

      params.ysfQrMin = this.dialogModel.ysfQrMin;

      params.ysfQrBigMax = this.dialogModel.ysfQrBigMax;

      params.ysfQrBigMin = this.dialogModel.ysfQrBigMin;

      //  if(this.dialogModel.otherSimStatus) {
      //   params.otherSimStatus = this.dialogModel.otherSimStatus
      // }

      params.otherSimAmt = this.dialogModel.otherSimAmt;

      params.firstSimAmt = this.dialogModel.firstSimAmt;

      params.returnFirstSimAmt = this.dialogModel.returnFirstSimAmt;

      params.returnOtherSimAmt = this.dialogModel.returnOtherSimAmt;

      params.otherSimDays = this.dialogModel.otherSimDays;

      params.acqActiveCode = this.dialogModel.acqActiveCode;

      params.otherAcqActiveCode = this.dialogModel.otherAcqActiveCode;

      params.firstDay = this.dialogModel.firstDay;

      params.lowAmt = this.dialogModel.lowAmt;

      params.batch = this.dialogModel.batch;

      params.hlfConfigThreeId = this.dialogModel.hlfConfigThreeId;

      params.returnFirstSimAmtTat = this.dialogModel.returnFirstSimAmtTat;

      params.returnOtherSimAmtTat = this.dialogModel.returnOtherSimAmtTat;

      params.ysfQrBigTat = this.dialogModel.ysfQrBigTat;

      params.ysfQrTat = this.dialogModel.ysfQrTat;

      params.alipayQrTat = this.dialogModel.alipayQrTat;

      params.wechatQrTat = this.dialogModel.wechatQrTat;

      params.debitTat = this.dialogModel.debitTat;

      params.creditTat = this.dialogModel.creditTat;

      params.chnCode = this.dialogModel.chnCode;

      params.chnCode2 = this.dialogModel.chnCode2;

      //  if(this.dialogModel.simShow) {
      //   params.simShow = this.dialogModel.simShow
      // }
      //  if(this.dialogModel.ysfQrBigShow) {
      //   params.ysfQrBigShow = this.dialogModel.ysfQrBigShow
      // }
      //  if(this.dialogModel.ysfQrShow) {
      //   params.ysfQrShow = this.dialogModel.ysfQrShow
      // }
      //  if(this.dialogModel.alipayQrShow) {
      //   params.alipayQrShow = this.dialogModel.alipayQrShow
      // }
      //  if(this.dialogModel.wechatQrShow) {
      //   params.wechatQrShow = this.dialogModel.wechatQrShow
      // }
      //  if(this.dialogModel.debitShow) {
      //   params.debitShow = this.dialogModel.debitShow
      // }
      //  if(this.dialogModel.creditShow) {
      //   params.creditShow = this.dialogModel.creditShow
      // }

      if (this.dialogModel.type == 2) {
        params.typeTwo = this.dialogModel.typeTwo;
      }

      if (this.itemId && !this.copy) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId && !this.copy ? activity.editList : activity.addList;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        payTypeScope: "",
        id: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getCouponList();
      this.getManageList();
    },
    zhuanhuaLiuliang(e) {
      let result = e.map((item) => item + "元");
      result = result.join(',')
      return result ;
    },
    getCouponList() {
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 100,
        },
        (res) => {
          this.couponList = res.contents.rows;
        },
        "信息获取失败"
      );
    },
    // 或者考核配置列表
    getManageList() {
      console.log("www");
      this.doLoad(
        TransactionService.threehappyreturnmanageList,
        {},

        (res) => {
          console.log(res.contents.rows, "考核res");
          let manageArr = [];
          res.contents.rows.forEach((item) => {
            manageArr.push(item.name);
          });
          let manageArrSave = [...new Set(manageArr)];
          this.manageArr = [...manageArrSave];
          console.log(this.manageArr, "w");
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        activity.deleteList,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        activity.udpStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (flag) {
        console.log("触发");
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId);
        this.copy = true;
        console.log(this.dialogModel, "触发1");
      }
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId);
        console.log(this.dialogModel, "this.dialogModel");
      }
      this.$refs.formDialog.open();
    },
    dialogClose() {
      this.dialogModel = {
        name: "",
        creditMax: undefined,
        creditMin: undefined,
        debitMax: undefined,
        debitMin: undefined,
        wechatQrMax: undefined,
        wechatQrMin: undefined,
        alipayQrMax: undefined,
        alipayQrMin: undefined,
        ysfQrMax: undefined,
        ysfQrMin: undefined,
        ysfQrBigMax: undefined,
        ysfQrBigMin: undefined,
        otherSimStatus: 0,
        otherSimAmt: undefined,
        firstSimAmt: undefined,
        // 新
        returnFirstSimAmt: undefined,
        returnOtherSimAmt: undefined,
        otherSimDays: "",
        firstDay: "",
        lowAmt: undefined,
        acqActiveCode: "",
        otherAcqActiveCode: "",
        batch: "",
        hlfConfigThreeId: "",
        returnFirstSimAmtTat: undefined,
        returnOtherSimAmtTat: undefined,
        ysfQrBigTat: undefined,
        ysfQrTat: undefined,
        alipayQrTat: undefined,
        wechatQrTat: undefined,
        debitTat: undefined,
        creditTat: undefined,
        simShow: 1,
        ysfQrBigShow: 1,
        ysfQrShow: 1,
        alipayQrShow: 1,
        wechatQrShow: 1,
        debitShow: 1,
        creditShow: 1,
        withdrawRateShow: 1,
        withdrawRate: undefined,
        simIsLong: 1
      };
      this.itemId = "";
      this.copy = false;
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
      
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
          this.tableData.forEach((item) => {
            if( item.simInfo) {
  item.simInfo = item.simInfo.split(",");
            }
        
        });
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    beforeAvatarUploadOther(file) {
      this.loading = true;
      console.log(file);
      const isVideo = file.type === "video/mp4";

      const isLt2M = file.size / 1024 / 1024 < 12;
      console.log(isVideo && !isLt2M, isVideo, !isLt2M);
      if (isVideo && !isLt2M) {
        this.loading = false;
        this.$message.error("上传视频大小不能超过 12MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    otherError() {
      this.loading = false;
    },
    formatterTableDataTypeTwo(row, column, cellValue, index) {
      let value = "--";
      if (row.type == 3) {
        return row.couponGroupName ? row.couponGroupName : value;
      }
      if (row.type == 2) {
        return cellValue ? cellValue : value;
      }
      return value;
    },
    formatterTableDataType(row, column, cellValue, index) {
      let value = "--";
      this.typeList.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
        this.loading = false;
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 70px;
  height: 70px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 70px;
  height: 70px;
  border: 1px dashed red;
  border-radius: 6px;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}
::v-deep.el-dialog__body {
  display: flex !important;
  flex-wrap: wrap !important;
}
/deep/.dialog .el-form-item {
  width: 47% !important;
}
/* /deep/.el-form .el-form--label-right {
  flex-wrap: wrap;
  display: flex;
} */
/* /deep/ .el-form--label-right {
  display: flex;

  flex-wrap: wrap;
} */
.flexBox {
  display: flex;
  flex-wrap: wrap;
}
.titleBox {
  font-size: 30px;
  padding: 0 20px 20px;
  color: rgb(126, 126, 231);
}
</style>



// WEBPACK FOOTER //
// src/view/page/InstitutionList/activity.vue